module.exports = __webpack_public_path__ + "static/media/case-study-3.af47a87a.jpg";